export default class BancoService {
  constructor(resource) {
    this._resource = resource;
  }

  getBancos() {
    return this._resource.get(`corpore/banco`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possivel obter os bancos");
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/domain/corpore/BancoService.js